// extracted by mini-css-extract-plugin
export default {"box":"styles_box__5DJqj","checkBox":"styles_checkBox__5mulf","container":"styles_container__mavDW","link":"styles_link__nzEcR"};